<script>
import bem from '@/utils/bem';

const b = bem('promo-texts');

export default {
  props: {
    bannerText: String,
    mobileBannerText: String,
    dropDownText: String,
    countDownText: String,
    countDown: Boolean,
    isIncludeBanner: Boolean,
    isHideIncludeBannerToggle: Boolean,
    isHidePromoData: Boolean,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    onChange(type, value) {
      this.$emit(`update:${type}`, value);
    },
  },
};
</script>

<template>
  <div :class="b('row', {hide: isHidePromoData})">
    <div :class="b('field-wrap')">
      <div :class="b('field-title-wrap')">
        <span :class="b('field-title')">Banner text:</span>
      </div>
      <a-input
          :class="b('field-input')"
          :value="bannerText"
          @change="(({ target: { value } }) => onChange('bannerText', value))"
      />
    </div>
    <div :class="b('field-wrap')">
      <div :class="b('field-title-wrap')">
        <span :class="b('field-title')">Mobile banner text:</span>
      </div>
      <a-input
          :class="b('field-input')"
          :value="mobileBannerText"
          @change="(({ target: { value } }) => onChange('mobileBannerText', value))"
      />
    </div>
  </div>
  <div :class="b('row', {hide: isHidePromoData})">
    <div :class="b('field-wrap')">
      <div :class="b('field-title-wrap')">
        <span :class="b('field-title')">Dropdown text:</span>
      </div>
      <a-input
          :class="b('field-input')"
          :value="dropDownText"
          @change="(({ target: { value } }) => onChange('dropDownText', value))"
      />
    </div>
    <div :class="b('field-wrap')">
      <div :class="b('field-title-wrap')">
        <span :class="b('field-title')">Countdown text:</span>
        <div :class="b('field-title-buttons')">
          <button
              :class="b('field-title-button', { on: countDown })"
              @click="() => {
                onChange('countDown', !countDown)
              }"
          >
            Show
          </button>
          /
          <button
              :class="b('field-title-button', { on: !countDown })"
              @click="() => {
                onChange('countDown', !countDown)
              }"
          >
            Don`t show
          </button>
        </div>
      </div>
      <a-input
          :class="b('field-input')"
          :value="countDownText"
          @change="(({ target: { value } }) => onChange('countDownText', value))"
      />
    </div>
    <div :class="b('field-wrap')" v-if="isHideIncludeBannerToggle">
      <div :class="b('field-title-wrap')">
        <span :class="b('field-title')">Show banner in ad:</span>
        <div :class="b('field-title-buttons')">
          <button
              :class="b('field-title-button', { on: isIncludeBanner })"
              @click="() => {
                onChange('isIncludeBanner', !isIncludeBanner)
              }"
          >
            Yes
          </button>
          /
          <button
              :class="b('field-title-button', { on: !isIncludeBanner })"
              @click="() => {
                onChange('isIncludeBanner', !isIncludeBanner)
              }"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";

  .promo-texts {
    &__row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;

      &_hide {
        display: none;
      }
    }
    &__field-wrap {
      display: flex;
      flex-direction: column;
      width: 45%;
      margin-bottom: 20px;

      @include mediaMinMax(1025, $normal) {
        margin-bottom: vw-full(20);
      }
    }

    &__field-title-wrap,
    &__field-buttons {
      display: flex;
      justify-content: space-between;
    }

    &__field-title-button {
      background: none;
      border: none;
      color: rgba($light-slate-gray-color, 0.5);
      cursor: pointer;

      &_on {
        color: $tacao;
      }
    }
  }
</style>
